module.exports = __webpack_public_path__ + "img/Group 6.937df9ec.svg";